import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const composeEmailActions = createActions(
  {
    COMPOSE_EMAIL_SEND: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    COMPOSE_EMAIL_FIND_USER: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    COMPOSE_EMAIL_GET_ALL_FROM: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    COMPOSE_EMAIL_GET_DRAFTS: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    COMPOSE_EMAIL_SAVE_DRAFT: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    COMPOSE_EMAIL_REMOVE_DRAFT: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'COMPOSE_EMAIL_SEND_SUCCEEDED',
  'COMPOSE_EMAIL_SEND_FAILED',

  'COMPOSE_EMAIL_FIND_USER_SUCCEEDED',
  'COMPOSE_EMAIL_FIND_USER_FAILED',

  'COMPOSE_EMAIL_GET_ALL_FROM_SUCCEEDED',
  'COMPOSE_EMAIL_GET_ALL_FROM_FAILED',

  'COMPOSE_EMAIL_GET_DRAFTS_SUCCEEDED',
  'COMPOSE_EMAIL_GET_DRAFTS_FAILED',

  'COMPOSE_EMAIL_SAVE_DRAFT_SUCCEEDED',
  'COMPOSE_EMAIL_SAVE_DRAFT_FAILED',

  'COMPOSE_EMAIL_REMOVE_DRAFT_SUCCEEDED',
  'COMPOSE_EMAIL_REMOVE_DRAFT_FAILED',

  'COMPOSE_EMAIL_OPEN_MODAL',
  'COMPOSE_EMAIL_SAVE_PARENT_CONV',
  'COMPOSE_EMAIL_CLOSE_MODAL',

  'COMPOSE_EMAIL_CHANGE_SATISFACTION_LANGUAGE',
  'COMPOSE_EMAIL_CANCEL_SATISFACTION_LANGUAGE',
);
